import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-callback',
  imports: [CommonModule],
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.css'
})
export class CallbackComponent implements OnInit {

  message = 'Procesando autenticación...';
  isError = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      const error = params['error'];

      if (error) {
        this.handleError(error);
      } else if (token) {
        this.handleSuccess(token);
      } else {
        this.handleError('No se recibió token de autenticación');
      }
    });
  }

  private handleSuccess(token: string): void {
    this.message = 'Autenticación exitosa. Redirigiendo...';
    this.authService.handleOffice365Callback(token);
  }

  private handleError(error: string): void {
    this.isError = true;
    this.message = `Error en la autenticación: ${error}`;
    
    setTimeout(() => {
      this.router.navigate(['/login'], { 
        queryParams: { error: error } 
      });
    }, 3000);
  }
}
